import variantsController from './variantsController'

export default variantsController



// WEBPACK FOOTER //
// ../src/controllers/variantsController/index.js